// The minimap's picture of the scan: the plan as a dashed outline, the covered
// area as a fill with a solid edge. Stays in the main bundle (the minimap
// draws it) and only calls methods on the masks it is handed, so the scan's
// own code can load on demand.

import { COVER_FILL, COVER_STROKE, PLAN_HALO, PLAN_STROKE } from './colors';
import type { CoverageMask } from './coverage';

export interface ScanMasks {
  plan: CoverageMask | null;
  coverage: CoverageMask | null;
  /** Changes whenever either mask does: the redraw key. */
  version: number;
}

/** Paint the masks over a `cssW` × `cssH` box. False when the canvas has no
 *  2D context (jsdom), which draws nothing and throws nothing. */
export function paintScanMasks(
  canvas: HTMLCanvasElement,
  masks: ScanMasks,
  cssW: number,
  cssH: number,
  dpr = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1,
): boolean {
  const w = Math.max(1, Math.round(cssW * dpr));
  const h = Math.max(1, Math.round(cssH * dpr));
  if (canvas.width !== w || canvas.height !== h) {
    canvas.width = w;
    canvas.height = h;
  }
  const ctx = canvas.getContext('2d');
  if (!ctx) return false;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  ctx.clearRect(0, 0, cssW, cssH);
  masks.plan?.drawInto(ctx, cssW, cssH, {
    stroke: PLAN_STROKE,
    lineWidth: 1,
    dash: [3, 2],
    halo: PLAN_HALO,
    haloWidth: 2.5,
    smooth: true,
  });
  masks.coverage?.drawInto(ctx, cssW, cssH, { fill: COVER_FILL, stroke: COVER_STROKE, lineWidth: 1 });
  return true;
}
